import React, { useState } from "react";

import Location from "../../../components/Location";
import { formatAddressLine } from "../../detail/detailMappers";
import DeliveryTypeSheet from "./DeliveryTypeSheet";

const TruckIcon = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M2 5.5h9v8H2zM11 8h3.4l2.6 2.8v2.7h-6z" />
    <circle cx="6" cy="15" r="1.6" />
    <circle cx="14" cy="15" r="1.6" />
  </svg>
);

const PinIcon = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M10 2.4c2.8 0 5 2.2 5 5 0 3.7-5 10.2-5 10.2S5 11.1 5 7.4c0-2.8 2.2-5 5-5Z" />
    <circle cx="10" cy="7.4" r="1.9" />
  </svg>
);

const deliveryText = (delivery) => {
  if (delivery.isLoading) return "Loading delivery options…";
  if (!delivery.selectedOption) return "No delivery type available";

  return delivery.selectedOption.etaText
    ? `${delivery.selectedOption.title} (${delivery.selectedOption.etaText})`
    : delivery.selectedOption.title;
};

const DeliveryAddressCard = ({ summary, delivery, addressState }) => {
  const [pickingType, setPickingType] = useState(false);
  const { address, setAddress, hasCoordinates } = addressState;

  return (
    <section className="sy-flow-card sy-checkout-delivery">
      <div className="sy-flow-card-head">
        <h2 className="sy-flow-card-title">Delivery</h2>
        <span className="sy-flow-card-note">Applies to every supplier in this order</span>
      </div>

      <div className="sy-flow-card-body">
        <div className="sy-flow-row">
          <div className="sy-flow-row-lead">
            <span className="sy-flow-row-icon">
              <TruckIcon />
            </span>

            <div className="sy-flow-row-body">
              <span className="sy-flow-row-label">Delivery type</span>
              <span
                className={`sy-flow-row-value${delivery.selectedOption ? "" : " is-placeholder"}`}
              >
                {deliveryText(delivery)}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="sy-flow-link"
            disabled={!delivery.sharedOptions.length}
            onClick={() => setPickingType(true)}
          >
            Change
          </button>
        </div>

        <div className="sy-flow-row">
          <div className="sy-flow-row-lead">
            <span className="sy-flow-row-icon">
              <PinIcon />
            </span>

            <div className="sy-flow-row-body">
              <span className="sy-flow-row-label">Delivery address</span>
              <span className={`sy-flow-row-value${hasCoordinates ? "" : " is-placeholder"}`}>
                {hasCoordinates ? formatAddressLine(address) : "Add a delivery address"}
              </span>
            </div>
          </div>

          <Location
            onLocationSelect={setAddress}
            value={address}
            label={hasCoordinates ? "Change" : "Add"}
            addressText={address?.address1 || ""}
          />
        </div>
      </div>

      {pickingType && (
        <DeliveryTypeSheet
          summary={summary}
          delivery={delivery}
          onClose={() => setPickingType(false)}
        />
      )}
    </section>
  );
};

export default DeliveryAddressCard;
